import { render, staticRenderFns } from "./QAdminNotices.vue?vue&type=template&id=79f1d890&scoped=true&"
import script from "./QAdminNotices.vue?vue&type=script&lang=js&"
export * from "./QAdminNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f1d890",
  null
  
)

export default component.exports